import React from 'react';
import Box from '@material-ui/core/Box';
import { makeDetailsStyles } from 'styles/pages/product';
import { CODES } from 'views/pages/Product/common/constants';

type Props = {
    codes: Array<string>;
    data: Array<{
        code: string;
        name: string;
        value: string;
    }>;
};

const transformText = (code: string, value: string) => {
    switch (code) {
        case CODES.BOOK_SERIES:
            return <i>{value}</i>;
        default:
            return value;
    }
};

const renderBookDetailsRow = ({ code, name, value }: any) => {
    const { table, tableData } = makeDetailsStyles();

    const headerClassName = `${tableData} ${name === 'ISBN' ? 'capitalize' : ''} header`;

    return (
        <Box key={code} className={table} display="flex">
            <Box className={headerClassName} flex={0.7}>
                {name}:
            </Box>
            <Box className={tableData} flex={1}>
                {transformText(code, value)}
            </Box>
        </Box>
    );
};

const Table: React.FC<Props> = ({ codes, data }) => {
    return (
        <>
            {codes
                .map((code) => data.find(({ code: dataCode }) => code === dataCode))
                .filter((code) => code)
                .map(renderBookDetailsRow)}
        </>
    );
};

export default Table;
